/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// Receives the .snipecorner URL and returns the text of the snipe span

const snipeListData = (snipeUrl) => {
    let snipe = snipeUrl;
    // cdn1.harryanddavid.com/wcsstore/HarryAndDavid/images/catalog/snipes/BuyOne_GetOne_Whack_z.gif?height=378&width=345
    // cdn1.harryanddavid.com/wcsstore/HarryAndDavid/images/catalog/snipes/BuyOne_GetOne_Whack_c.gif
    const snipeRegex = /[\s\S]+\/([^.]+)\.gif\??[\s\S]*/;
    if (snipeUrl && snipeUrl.match(snipeRegex)) {
        snipe = snipeUrl.replace(snipeRegex, '$1');
    }
    const snipeObj = [{
        // Promotion
        promotionSnipe: {
            '1099_shipping_event_thumb_c': '$10.99 Shipping Event',
            '1099_shipping_event_feat_z': '$10.99 Shipping Event',
            '1099_shipping_event_feat': '$10.99 Shipping Event',
            '1199_shiping_event_c': '$11.99 Shipping Event',
            '1199_shiping_event_z': '$11.99 Shipping Event',
            '1199_shiping_event': '$11.99 Shipping Event',
            HD_1499FlatRateShip_c: '$14.99 Flat-Rate Shipping',
            HD_1499FlatRateShip_z: '$14.99 Flat-Rate Shipping',
            HD_1499FlatRateShip: '$14.99 Flat-Rate Shipping',
            HD_1999_ship_c: '$19.99 FLAT- RATE SHIPPING',
            HD_1999_ship_z: '$19.99 FLAT- RATE SHIPPING',
            HD_1999_ship: '$19.99 FLAT- RATE SHIPPING',
            '5_shipping_event_thumb_pre_c': '$5 Shipping Event',
            '5_shipping_event_feat_pre_z': '$5 Shipping Event',
            '5_shipping_event_feat_pre': '$5 Shipping Event',
            '899_shipping_event_thumb_c': '$8.99 Shipping Event',
            '899_shipping_event_feat_z': '$8.99 Shipping Event',
            '899_shipping_event_feat': '$8.99 Shipping Event',
            hd_999flatrateshipping_thumb_pre_c: '$9.99 Flat-Rate Shipping',
            hd_999flatrateshipping_feat_pre_z: '$9.99 Flat-Rate Shipping',
            hd_999flatrateshipping_feat_pre: '$9.99 Flat-Rate Shipping',
            '999_shiping_event_thmub_pre_c': '$9.99 Shipping Event',
            '999_shiping_event_feat_pre_z': 'Shipping Event - $9.99',
            '999_shiping_event_feat_pre': 'Shipping Event - $9.99',
            HD_Buy2save20_c: 'BUY ANY 2 - SAVE $20',
            HD_Buy2save20_z: 'BUY ANY 2 - SAVE $20',
            HD_Buy2save20: 'BUY ANY 2 - SAVE $20',
            HD_buy2save30_c: 'Buy Any 2 | Save $30',
            HD_buy2save30_z: 'Buy Any 2 | Save $30',
            HD_buy2save30: 'Buy Any 2 | Save $30',
            buy_one_get_one_c: 'Buy One | Get One 50% Off',
            HD_buy_one_get_one_z: 'Buy One | Get One 50% Off',
            HD_buy_one_get_one: 'Buy One | Get One 50% Off',
            HD_save15_c: 'SAVE 15%',
            HD_save15_z: 'SAVE 15%',
            HD_save15: 'SAVE 15%',
            hd_save20percent_thumb_pre_c: 'Save 20%',
            'HD-Save20-218wide_c': 'Save 20%',
            hd_save20percent_feat_pre_z: 'SAVE 20%',
            hd_save20percent_feat_pre: 'SAVE 20%',
            hd_save20_thumb_pre_c: 'Save 20% Today',
            hd_save20_feat_pre_z: 'Save 20% Today',
            hd_save20_feat_pre: 'Save 20% Today',
            'HD-Save25-218wide_c': 'Save 25%',
            hd_save25_thumb_pre_c: 'SAVE 25% TODAY',
            hd_save25_feat_pre_z: 'SAVE 25% TODAY',
            hd_save25_feat_pre: 'SAVE 25% TODAY',
            'HD-Save30-218wide_c': 'Save 30%',
            hd_save30_thumb_pre_c: 'Save 30% Today',
            hd_save30_feat_pre_z: 'SAVE 30% TODAY',
            hd_save30_feat_pre: 'SAVE 30% TODAY',
            '1199_shiping_event_feat_pre_z': '$11.99 Shipping Event',
            '1199_shiping_event_thumb_pre_c': '$11.99 Shipping Event',
            '1199_shipping_event_c': '$11.99 SHIPPING EVENT',
            '1199_shipping_event_z': '$11.99 SHIPPING EVENT',
            '1199_shiping_event_feat_pre': '$11.99 Shipping Event',
            '1199_shipping_event': '$11.99 SHIPPING EVENT',
            '50off_c': '50% Off',
            '50percentoff_c': '50% Off with Code OFF50',
            '50percentoffbig_c': '50% Off with Code OFF50',
            '999_shiping_event_thumb_pre_c': '$9.99 Shipping Event',
            flat_rate1499_c: '$14.99 FLAT RATE SHIPPING',
            flat_rate1499_z: '$14.99 FLAT RATE SHIPPING',
            flat_rate5_c: '$5 SHIPPING EVENT',
            flat_rate5_z: '$5 SHIPPING EVENT',
            flat_rate5: '$5 SHIPPING EVENT',
            flat_rate9_c: '$9.99 FLAT RATE SHIPPING',
            flat_rate9_z: '$9.99 FLAT RATE SHIPPING',
            flat_rate9: '$9.99 FLAT RATE SHIPPING',
            'HD-Save25-218_wide_c': 'Save 25%',
            'HD-Save30-218_wide_c': 'Save 30%',
            // WOLF snipe
            wf_1199_flatrate_Thumb_Pre_c: '$11.99 Flat-Rate Shipping',
            wf_1199_flatrate_Feat_Pre_z: '$11.99 Flat-Rate Shipping',
            wf_1199_flatrate_Feat_Pre: '$11.99 Flat-Rate Shipping',
            wf_1199_shipping_event_thumb_c: '$11.99 Shipping Event',
            wf_1199_shipping_event_feat_z: '$11.99 Shipping Event',
            wf_1199_shipping_event_feat: '$11.99 Shipping Event',
            WF_1499_ship: '$14.99 Flat-Rate Shipping',
            WF_1499_ship_c: '$14.99 Flat-Rate Shipping',
            WF_1499_ship_z: '$14.99 Flat-Rate Shipping',
            '5dollarshipping_thumb_Pre_c': '$5 Shipping',
            '5dollarshipping_feat_Pre_z': '$5 Shipping',
            '5dollarshipping_feat_Pre': '$5 Shipping',
            WF_5_dollar_ship_event_c: '$5 Shipping Event',
            WF_5_dollar_ship_event_z: '$5 Shipping Event',
            WF_5_dollar_ship_event: '$5 Shipping Event',
            wf_999_flatrate_Thumb_pre_c: '$9.99 Flat-Rate Shipping',
            wf_999_flatrate_Feat_pre_z: '$9.99 Flat-Rate Shipping',
            wf_999_flatrate_Feat_pre: '$9.99 Flat-Rate Shipping',
            wf_999_shipping_event_thumb_c: '$9.99 Shipping Event',
            wf_999_shipping_event_feat_z: '$9.99 Shipping Event',
            wf_999_shipping_event_feat: '$9.99 Shipping Event',
            WF_buy2save30_c: 'Buy Any 2 | Save $30',
            WF_buy2save30_z: 'Buy Any 2 | Save $30',
            WF_buy2save30: 'Buy Any 2 | Save $30',
            // 'buy_one_get_one_c': 'Buy One | Get One 50% Off', // Duplicate key
            WF_buyonegetone_c: 'Buy One | Get One 50% Off',
            buy_one_get_one_z: 'Buy One | Get One 50% Off',
            WF_buyonegetone_z: 'Buy One | Get One 50% Off',
            buy_one_get_one: 'Buy One | Get One 50% Off',
            WF_buyonegetone: 'Buy One | Get One 50% Off',
            save_20percent_thumb_pre_c: 'Save 20%',
            save_20percent_feat_pre_z: 'Save 20%',
            save_20percent_feat_pre: 'Save 20%',
            wf_save20_thumb_pre_c: 'Save 20% Today',
            wf_save20_feat_pre_z: 'Save 20% Today',
            wf_save20_feat_pre: 'Save 20% Today',
            wf_save25_thumb_pre_c: 'Save 25% Today',
            wf_save25_feat_pre_z: 'Save 25% Today',
            wf_save25_feat_pre: 'Save 25% Today',
            wf_save30_thumb_pre_c: 'Save 30% Today',
            wf_save30_feat_pre_z: 'Save 30% Today',
            wf_save30_feat_pre: 'Save 30% Today',
            WF_buy_one_get_one_c: 'Buy One | Get One 50% Off',
            WF_buy_one_get_one_z: 'Buy One | Get One 50% Off',

            // SY snipe
            sy_999flatrateshipping_c: '$9.99 Flat-Rate Shipping',
            sy_999flatrateshipping_z: '$9.99 Flat-Rate Shipping',
            sy_999flatrateshipping: '$9.99 Flat-Rate Shipping',
            // HDFOB-723
            '799-ShipThumbWhack_c': '$7.99 FLAT RATE SHIPPING',
            '799-ShipFeatWhack_z': '$7.99 Flat Rate',
            // 'flat_rate1499_c': '$14.99 Flat-Rate', // duplicate snipe key
            // 'flat_rate1499_z': '$14.99 Flat-Rate', // duplicate snipe key
            'half-off-Whack_c': 'BUY ONE - GET ONE 50% OFF',
            'half-off-Whack_z': 'BUY ONE - GET ONE 50% OFF',
            // HDFOB-760
            BuyOne_GetOne_Whack_c: 'BUY ONE - GET ONE 50% OFF',
            BuyOne_GetOne_Whack_z: 'BUY ONE - GET ONE 50% OFF',
            hd_save20percent_thumb_pre: 'SAVE 20%',
            hd_save25_thumb_pre: 'SAVE 25% TODAY',
            hd_save30_thumb_pre: 'SAVE 30% TODAY',
            // DE30723 - Missing HD Snipes
            '50off': '50% OFF',
            '599_event_pre': '$5.99 SHIPPING EVENT',
            '599_event_pre_z': '$5.99 SHIPPING EVENT',
            '999_shiping_event_thumb_pre': '$9.99 SHIPPING EVENT',
            BuyOne_GetOne_Whack: 'BUY ONE - GET ONE 50% OFF',
            flat_rate1499: '$14.99 FLAT RATE SHIPPING',
            // PWAM: 21 - New snipes
            '799-ShipThumbWhack': '$7.99 FLAT RATE SHIPPING',
            free_gift_thumb_pre: 'FREE GIFT WITH PURCHASE',
            free_gift_thumb_pre_z: 'FREE GIFT WITH PURCHASE',
            free_gift_feat_pre_z: 'Free Gift With Purchase',
            ships_free_thumb2_pre: 'SHIPS FREE',
            ships_free_thumb2_pre_z: 'SHIPS FREE',
            ships_free_feat2_pre_z: 'SHIPS FREE',
            FreeShippingThumbWhackPre_c: 'FREE SHIPPING',
            FreeShippingFeatWhackPre_z: 'FREE SHIPPING',
            FreeShippingFeatWhackPre: 'Free Shipping',
            FreeShippingCheckFeatWhack_z: 'FREE SHIPPING',
            FreeShippingCheckThumbWhack_c: 'FREE SHIPPING',
            FreeShippingFeatWhackPre2: 'FREE SHIPPING',
            FreeShippingThumbWhack_k: 'FREE SHIPPING',
            freedelivery_c: 'Free Shipping',
            freedeliveryfeature_z: 'Free Shipping',
            freedeliveryfeature: 'Free Shipping',
            shipforsummer_c: 'Free Shipping with Code SHIP4SUMMER',
            shipforsummerprod: 'Free Shipping with Code SHIP4SUMMER',
            shipforsummerprod_c: 'Free Shipping with Code SHIP4SUMMER',
            shipforsummerprod_z: 'Free Shipping with Code SHIP4SUMMER',
            HD_BlackFridaySale_c: 'BLACK FRIDAY SALE',
            HD_BlackFridaySale_z: 'BLACK FRIDAY SALE',
            WF_BlackFridaySale_c: 'Black Friday Sale',
            WF_BlackFridaySale_z: 'Black Friday Sale',
            FreeMMThumbWhack: 'FREE MOOSE MUNCH WITH PURCHASE',
            FreeMMFeatWhack_z: 'FREE MOOSE MUNCH WITH PURCHASE',
            FreeChocolatesThumbWhack: 'FREE CHOCOLATES WITH PURCHASE',
            FreeChocolatesFeatWhack_z: 'FREE CHOCOLATES WITH PURCHASE',
            // STOC-15
            'buymore-savemore': 'BUY MORE - SAVE MORE',
            'buymore-savemore_z': 'BUY MORE - SAVE MORE',
            green_monday: 'GREEN MONDAY SAVINGS',
            green_monday_z: 'GREEN MONDAY SAVINGS',
            FreeShippingThumbWhackPre: 'FREE SHIPPING',
            '1499Ship_feat': '$14.99 FLAT RATE SHIPPING',
            'buymore-savemore-whack': 'BUY MORE - SAVE MORE',
            shipping_included_pre: 'SHIPPING INCLUDED',
        },

        everygreenSnipe: {
            // Client wanted to hide Add Wine snipe globally
            WF_MixnMatch: 'Mix & Match',
            CreateYourOwn: 'CREATE YOUR OWN',
            Add_wine_thumb_Pre_c: 'Add Wine',
            Add_wine_feat_Pre_z: 'Add Wine',
            Add_wine_feat_Pre: 'Add Wine',
            award_winning_c: 'AWARD-WINNING WINE',
            award_winning_v2_c: 'AWARD-WINNING WINE',
            award_winning_v2_z: 'AWARD-WINNING WINE',
            award_winning_z: 'AWARD-WINNING WINE',
            award_winning_v2: 'AWARD-WINNING WINE',
            award_winning: 'AWARD-WINNING WINE',
            bestprice_thumb_pre_c: 'Best Price of the Season',
            bestprice_feature_pre_z: 'Best Price of the Season',
            bestprice_feature_pre: 'Best Price of the Season',
            HD_black_friday_thumb_2015_pre_c: 'Black Friday Sale',
            HD_black_friday_feature_2015_pre_z: 'Black Friday Sale',
            HD_black_friday_feature_2015_pre: 'Black Friday Sale',
            complimetaryship_thumb_Pre_c: 'Complementary Shipping',
            complimentaryship_feat_Pre_z: 'Complementary Shipping',
            complimentaryship_feat_Pre: 'Complementary Shipping',
            HD_cybermonday_thumb_pre_c: 'CYBER MONDAY SALE',
            HD_cyber_monday_feature_pre_z: 'CYBER MONDAY SALE',
            HD_cyber_monday_feature_pre: 'CYBER MONDAY SALE',
            HD_deal_ofthe_day_c: 'Deal of the Day',
            HD_deal_ofthe_day_z: 'Deal of the Day',
            HD_deal_ofthe_day: 'Deal of the Day',
            finaldayfeat_pre_c: 'Final Day to Order',
            finaldaythumb_pre_z: 'Final Day to Order',
            finaldaythumb_pre: 'Final Day to Order',
            saturday_delivery_thumb_c: 'Guaranteed by 5/7, No Extra Charge',
            saturday_delivery_feat_z: 'Guaranteed by 5/7, No Extra Charge',
            saturday_delivery_feat: 'Guaranteed by 5/7, No Extra Charge',
            GuarantdXmasThumbPre_c: 'Guaranteed by Christmas',
            GuarantdXmasFeaturePre_z: 'Guaranteed by Christmas',
            GuarantdXmasFeaturePre: 'Guaranteed by Christmas',
            HD_kosher_thumb_pre_c: 'Kosher',
            HD_kosher_feature_pre_z: 'Kosher',
            HD_kosher_feature_pre: 'Kosher',
            hd_NEW_c: 'New',
            hd_NEW: 'New',
            hd_NEW_z: 'New',
            NowShipping_thumb_pre_c: 'Now Shipping',
            NowShipping_feat_pre_z: 'Now Shipping',
            NowShipping_feat_pre: 'Now Shipping',
            order_now_jan_thumb_pre_c: 'Order Now for January',
            order_now_jan_feat_pre_z: 'Order Now for January',
            order_now_jan_feat_pre: 'Order Now for January',
            overlay_shipsOvernight_thumb_pre_c: 'Overnight Shipping',
            overlay_shipsOvernight_feature_pre_z: 'Overnight Shipping',
            overlay_shipsOvernight_feature_pre: 'Overnight Shipping',
            personalizeThumbPre_c: 'PERSONALIZE IT',
            personalizeFeaturePre_z: 'PERSONALIZE IT',
            personalizeFeaturePre: 'PERSONALIZE IT',
            pre_black_friday_HD_thumb_pre_c: 'Pre-Black Firday Sale',
            pre_black_friday_HD_feature_pre_z: 'Pre-Black Firday Sale',
            pre_black_friday_HD_feature_pre: 'Pre-Black Firday Sale',
            'Reserve_Now_2016_thumb-01_Pre_c': 'Reserve Now for 2016',
            Reserve_Now_2016_feat_Pre_z: 'Reserve Now for 2016',
            Reserve_Now_2016_feat_Pre: 'Reserve Now for 2016',
            reserve_jan_thumb_c: 'Reserve Now for January',
            reserve_jan_feat_z: 'Reserve Now for January',
            reserve_jan_feat: 'Reserve Now for January',
            rosh_hashannah_c: 'Rosh Hashanah',
            rosh_hashannah_z: 'Rosh Hashanah',
            rosh_hashannah: 'Rosh Hashanah',
            Sale_thumb_Pre_c: 'Sale',
            Sale_Feat_Pre_z: 'Sale',
            Sale_Feat_Pre: 'Sale',

            HD_ships_april_c: 'SHIPS IN APRIL',
            HD_ships_april_z: 'SHIPS IN APRIL',
            HD_ships_april: 'SHIPS IN APRIL',
            ships_august_thumb_c: 'Ships in August',
            ships_august_feat_z: 'Ships in August',
            ships_august_feat: 'Ships in August',
            HD_ships_dec_c: 'Ships in Decemeber',
            HD_ships_dec_z: 'Ships in Decemeber',
            HD_ships_dec: 'SHIPS IN DECEMBER',
            HD_ships_feb_c: 'Ships in February',
            HD_ships_feb_z: 'Ships in February',
            HD_ships_feb: 'SHIPS IN FEBRUARY',
            ships_july_thumb_c: 'Ships in July',
            ships_july_feat_z: 'Ships in July',
            ships_july_feat: 'Ships in July',
            ships_june_thumb_c: 'Ships in June',
            ships_june_feat_z: 'Ships in June',
            ships_june_feat: 'Ships in June',
            HD_ships_march_c: 'Ships in March',
            HD_ships_march_z: 'Ships in March',
            HD_ships_march: 'SHIPS IN MARCH',
            HD_ships_may_c: 'Ships in May',
            HD_ships_may_z: 'Ships in May',
            HD_ships_may: 'SHIPS IN MAY',
            HD_ships_nov_c: 'Ships in November',
            HD_ships_nov_z: 'Ships in November',
            HD_ships_nov: 'SHIPS IN NOVEMBER',
            HD_ships_oct_c: 'Ships in October',
            HD_ships_oct_z: 'Ships in October',
            HD_ships_oct: 'SHIPS IN OCTOBER',
            ships_september_thumb_c: 'Ships in September',
            ships_september_feat_z: 'Ships in September',
            ships_september_feat: 'Ships in September',
            Ships2day_thumb_pre_c: 'Two-Day Shipping',
            Ships2day_feat_pre_z: 'Two-Day Shipping',
            Ships2day_feat_pre: 'Two-Day Shipping',
            organic_c: 'USDA Organic',
            organicfeature_z: 'USDA ORGANIC',
            organicfeature: 'USDA ORGANIC',
            weeklyspotlight_thumb_Pre_c: 'Weekly Spotlight Savings',
            weeklyspotlight_feature_Pre_z: 'Weekly Spotlight Savings',
            weeklyspotlight_feature_Pre: 'Weekly Spotlight Savings',

            // New snipes update on March 1, 2018
            // 'food_wine_2017': 'Logo - Harry & David Food & Wine Collection',
            // 'HD_AmericanHomeGrown_2017': 'Logo - Americana Heart',
            HD_HolidayPreview_c: 'Holiday Preview',
            HD_HolidayPreview_z: 'Holiday Preview',
            organic_2017: 'Organic',
            weeklyspotlight_2017: 'Weekly Spotlight Savings',
            // 'HD_larks': 'Logo - Larks',
            // 'HD_larks_c': 'Logo - Larks',
            // 'HD_larks_z': 'Logo - Larks',
            overlay_2DayShip_feature_z: 'Two-Day Shipping',
            overlay_2DayShip_thumb_c: 'Two-Day Shipping',
            Ships2dayb_feat_pre: 'Ships Two Day',
            Ships2dayb_thumb_pre: 'Ships Two Day',
            Ships2dayb_thumb_pre_c: 'Ships Two Day',
            shipsOvernightb_feature_pre: 'Ships Overnight',
            shipsOvernightb_thumb_pre: 'Ships Overnight',

            // TODO: need to confirm with client/designer about snipe below
            // 'food_wine_c','Logo - Harry & David Food & Wine Collection',
            // 'HD_AmericanHomeGrown_c','Logo - Americana Heart',
            // 'oprahs_fav_2016_c','Logo - Oprah 2016',
            // 'oprahs_fav_thumbnail_c','Logo - Oprah 2015',
            // 'food_wine_z','Logo - Harry & David Food & Wine Collection',
            // 'food_wine','Logo - Harry & David Food & Wine Collection',
            // 'HD_AmericanHomeGrown_z','Logo - Americana Heart',
            // 'oprahs_fav_2016_z','Logo - Oprah 2016',
            // 'oprahs_fav_feature_z','Logo - Oprah 2015',
            // 'HD_AmericanHomeGrown','Logo - Americana Heart',
            // 'oprahs_fav_2016','Logo - Oprah 2016',
            // 'oprahs_fav_feature','Logo - Oprah 2015',

            WF_Black_friday_thumb_2015_pre_c: 'Black Friday Sale',
            WF_black_friday_feature_2015_pre_z: 'Black Friday Sale',
            WF_black_friday_feature_2015_pre: 'Black Friday Sale',

            WF_cybermonday_thumb_pre_c: 'Cyber Monday Sale',
            WF_cybermonday_feature_pre_z: 'Cyber Monday Sale',
            WF_cybermonday_feature_pre: 'Cyber Monday Sale',
            GtdChristmasThumbPre_c: 'Guaranteed by Christmas',
            GtdChristmasFeatPre_z: 'Guaranteed by Christmas',
            GtdChristmasFeatPre: 'Guaranteed by Christmas',
            wolf_overlay_shipsOvernight_thumb_pre_c: 'Overnight Shipping',
            wolf_overlay_shipsOvernight_feat_pre_z: 'Overnight Shipping',
            wolf_overlay_shipsOvernight_feat_pre: 'Overnight Shipping',
            wf_sale_thumb_pre_c: 'Sale',
            wf_sale_feat_pre_z: 'Sale',
            wf_sale_feat_pre: 'Sale',

            wolf_Ships2day_thumb_pre_c: 'Two-Day Shipping',
            wolf_Ships2day_feat_pre_z: 'Two-Day Shipping',
            wolf_Ships2day_feat_pre: 'Two-Day Shipping',

            // New snipes update on March 1, 2018
            // 'CreateYourOwn_2017': 'Logo - Wolferman\'s Create Your Own',
            // 'CreateYourOwn_c': 'Logo - Wolferman\'s Create Your Own',
            // 'CreateYourOwn_z': 'Logo - Wolferman\'s Create Your Own',
            // 'WF_MixnMatch_2017': 'Logo - Wolferman\'s Mix & Match',
            // 'WF_MixnMatch_c': 'Logo - Wolferman\'s Mix & Match',
            // 'WF_MixnMatch_z': 'Logo - Wolferman\'s Mix & Match',
            // 'create_your_own_c': 'Logo - Wolferman\'s Create Your Own',
            // 'create_your_own_z': 'Logo - Wolferman\'s Create Your Own',
            freedelivery2_c: '&#x2713; Ships Free',
            freedeliveryfeature2_z: '&#x2713; Ships Free',

            BestSeller_c: 'Best Seller',
            BestSeller: 'Best Seller',
            BestSeller_z: 'Best Seller',
            sy_grassfed_c: 'Grass Fed',
            sy_grassfed_z: 'Grass Fed',
            sy_grassfed: 'Grass Fed',
            sy_NEW_c: 'New',
            sy_NEW_z: 'New',
            sy_NEW: 'New',
            SY_save_on_select_c: 'Save On Select Items',
            SY_save_on_select_z: 'Save On Select Items',
            SY_save_on_select: 'Save On Select Items',
            SY_special_prices_c: 'Special Price',
            SY_special_prices_z: 'Special Price',
            SY_special_prices: 'Special Price',

            // New snipes update on March 1, 2018
            // 'SY_Bestsellers_c': 'Logo-Best Sellers',
            // 'SY_Bestsellers_z': 'Logo-Best Sellers',
            // 'SY_Bestsellers_c': 'Logo-Best Sellers',
            // 'SY_Bestsellers_z': 'Logo-Best Sellers',
            // 'SY_BestSeller': 'Logo-Best Sellers',
            // 'SY_BestSeller_c': 'Logo-Best Sellers',
            // 'SY_BestSeller_z': 'Logo-Best Sellers',
            // 'SY_Bestsellers': 'Logo-Best Sellers',
            // 'SY_BetterBestsellers': 'Logo-Best Sellers',
            // 'SY_BetterBestsellers_c': 'Logo-Best Sellers',
            // 'SY_BetterBestsellers_z': 'Logo-Best Sellers',

            Ships2day_thumb_pre_z: 'Two-Day Shipping',

            // HDFOB-829
            ships_overnight_thumb2_pre: 'OVERNIGHT SHIPPING',
            ships_overnight_thumb2_pre_z: 'OVERNIGHT SHIPPING',
            ships_overnight__feat2_pre_z: 'OVERNIGHT SHIPPING',
            ships_2day_thumb2_pre: '2 DAY SHIPPING',
            ships_2day_thumb2_pre_z: '2 DAY SHIPPING',
            ships_2day_feat2_pre_z: '2 DAY SHIPPING',
            reserve_jan_thumb2_pre: 'RESERVE NOW FOR JANUARY',
            reserve_jan_thumb2_pre_z: 'RESERVE NOW FOR JANUARY',
            reserve_jan_feat2_pre_z: 'Reserve for January',
            Add_wine_thumb2_pre: 'ADD WINE',
            Add_wine_thumb2_pre_z: 'Add Wine',
            Add_wine_feat2_pre_z: 'Add Wine',
            smile_farms_thumb_pre: 'SMILE FARMS',
            smile_farms_thumb_pre_z: 'SMILE FARMS',
            smile_farms_feat_pre_z: 'SMILE FARMS',
            // HDFOB-865

            food_wine: 'FOOD & WINE COLLECTION',
            HD_BlackFridaySale: 'BLACK FRIDAY SALE',
            HD_HolidayPreview: 'HOLIDAY PREVIEW',
            HD_larks: 'LARKS HOME KITCHEN CUISINE',
            personalizeThumbPre: 'PERSONALIZE IT',
            'shipping-included-pre': 'SHIPPING INCLUDED',
            'shipping-included-pre_z': 'SHIPPING INCLUDED',
            ships_2day_feat2_pre_v2: 'SHIPS TWO DAY',
            ships_2day_feat2_pre_z_v2: 'Ships Two Day',
            ships_august_thumb: 'SHIPS IN AUGUST',
            ships_july_thumb: 'SHIPS IN JULY',
            ships_july_thumb_z: 'Ships in July',
            ships_june_thumb: 'Ships in June',
            ships_june_thumb_z: 'Ships in June',
            ships_overnight__feat2_pre_v2: 'SHIPS OVERNIGHT',
            ships_overnight__feat2_pre_z_v2: 'SHIPS OVERNIGHT',
            ships_september_thumb: 'SHIPS IN SEPTEMBER',
        },
    }];

    snipeObj.filter((item) => {
        Object.entries(item).forEach(([category, snipeItems]) => {
            if (snipeItems[snipe]) {
                snipe = {
                    snipe: snipeItems[snipe],
                    class: category,
                };
            }
            return null;
        });
        return null;
    });

    return snipe;
};

export default snipeListData;
